module.exports = __webpack_public_path__ + "01_hair_gold.428923b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/01_hair_gold.png
// module id = aJZ3
// module chunks = 0